import React from 'react';

import { MDText } from 'i18n-react';

import { ULEZ_CHECKER_EVENTS } from 'Utilities/analytics';

import LocalTexts from '../../../containers/app/contentPages/ulezPage/ulezText.json';
import useHandleVRMUlezSubmit from '../../vrm/VrmUlezChecker/useHandleVRMUlezSubmit';

import StickyVRM from './StickyVRM';

const LocalT = new MDText(LocalTexts);

const StickyVRMUlez = (params) => {
  const { disabled, handleVRMUlezSubmit: onSubmit } = useHandleVRMUlezSubmit();

  const ctaLabel = LocalT.translate('vrmBox.buttonLabel');

  return (
    <StickyVRM
      analyticsEvents={ {
        onButtonClick: () => ULEZ_CHECKER_EVENTS.VRM_CTA_CLICKED('sticky', ctaLabel),
      }}
      {...{ disabled, onSubmit }}
      {...params}
      desktopCTA={ctaLabel}
      header={LocalT.translate('vrmBox.widgetTitle')}
    />
  );
};

export default StickyVRMUlez;
